import { Button, buttonVariants } from '@ondit/ui'
import { ArrowLeft, Compass, Home } from '@ondit/ui/icons'
import { Link, useNavigate, useParams } from 'react-router'
import { ErrorShell } from '@/screens/workspace/components'

export default function WorkspaceNotFound() {
  const navigate = useNavigate()
  const { workspaceId } = useParams() as { workspaceId?: string }
  const homeHref = workspaceId ? `/w/${workspaceId}/agent` : '/'

  return (
    <ErrorShell
      title='Page not found'
      description="The page you're looking for doesn't exist or has been moved. Head back to your workspace to keep building."
      icon={<Compass className='size-[22px]' />}
    >
      <Button variant='default' size='md' onClick={() => navigate(-1)}>
        <ArrowLeft className='mr-1.5 size-[14px]' />
        Go back
      </Button>
      <Link to={homeHref} className={buttonVariants({ variant: 'primary', size: 'md' })}>
        <Home className='mr-1.5 size-[14px]' />
        Return home
      </Link>
    </ErrorShell>
  )
}
